module.exports = __webpack_public_path__ + "static/media/edit-2.55ffc8b9.svg";